/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProxyResponse } from './ProxyResponse';
import {
    ProxyResponseFromJSON,
    ProxyResponseFromJSONTyped,
    ProxyResponseToJSON,
    ProxyResponseToJSONTyped,
} from './ProxyResponse';
import type { RegionResponse } from './RegionResponse';
import {
    RegionResponseFromJSON,
    RegionResponseFromJSONTyped,
    RegionResponseToJSON,
    RegionResponseToJSONTyped,
} from './RegionResponse';
import type { AppParametersResponse } from './AppParametersResponse';
import {
    AppParametersResponseFromJSON,
    AppParametersResponseFromJSONTyped,
    AppParametersResponseToJSON,
    AppParametersResponseToJSONTyped,
} from './AppParametersResponse';
import type { DeviceInfoResponse } from './DeviceInfoResponse';
import {
    DeviceInfoResponseFromJSON,
    DeviceInfoResponseFromJSONTyped,
    DeviceInfoResponseToJSON,
    DeviceInfoResponseToJSONTyped,
} from './DeviceInfoResponse';

/**
 * 
 * @export
 * @interface PersonaResponse
 */
export interface PersonaResponse {
    /**
     * 
     * @type {string}
     * @memberof PersonaResponse
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof PersonaResponse
     */
    personaType: string;
    /**
     * 
     * @type {string}
     * @memberof PersonaResponse
     */
    labels: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonaResponse
     */
    demographic: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PersonaResponse
     */
    groups: Array<string>;
    /**
     * 
     * @type {RegionResponse}
     * @memberof PersonaResponse
     */
    region: RegionResponse | null;
    /**
     * 
     * @type {Array<AppParametersResponse>}
     * @memberof PersonaResponse
     */
    appParameters?: Array<AppParametersResponse> | null;
    /**
     * 
     * @type {DeviceInfoResponse}
     * @memberof PersonaResponse
     */
    deviceInfo?: DeviceInfoResponse | null;
    /**
     * 
     * @type {ProxyResponse}
     * @memberof PersonaResponse
     */
    proxy?: ProxyResponse | null;
}

/**
 * Check if a given object implements the PersonaResponse interface.
 */
export function instanceOfPersonaResponse(value: object): value is PersonaResponse {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('personaType' in value) || value['personaType'] === undefined) return false;
    if (!('labels' in value) || value['labels'] === undefined) return false;
    if (!('demographic' in value) || value['demographic'] === undefined) return false;
    if (!('groups' in value) || value['groups'] === undefined) return false;
    if (!('region' in value) || value['region'] === undefined) return false;
    return true;
}

export function PersonaResponseFromJSON(json: any): PersonaResponse {
    return PersonaResponseFromJSONTyped(json, false);
}

export function PersonaResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonaResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
        'personaType': json['persona_type'],
        'labels': json['labels'],
        'demographic': json['demographic'],
        'groups': json['groups'],
        'region': RegionResponseFromJSON(json['region']),
        'appParameters': json['app_parameters'] == null ? undefined : ((json['app_parameters'] as Array<any>).map(AppParametersResponseFromJSON)),
        'deviceInfo': json['device_info'] == null ? undefined : DeviceInfoResponseFromJSON(json['device_info']),
        'proxy': json['proxy'] == null ? undefined : ProxyResponseFromJSON(json['proxy']),
    };
}

export function PersonaResponseToJSON(json: any): PersonaResponse {
    return PersonaResponseToJSONTyped(json, false);
}

export function PersonaResponseToJSONTyped(value?: PersonaResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
        'persona_type': value['personaType'],
        'labels': value['labels'],
        'demographic': value['demographic'],
        'groups': value['groups'],
        'region': RegionResponseToJSON(value['region']),
        'app_parameters': value['appParameters'] == null ? undefined : ((value['appParameters'] as Array<any>).map(AppParametersResponseToJSON)),
        'device_info': DeviceInfoResponseToJSON(value['deviceInfo']),
        'proxy': ProxyResponseToJSON(value['proxy']),
    };
}

